import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';
import { TransformPhoneNoPipe } from '../../../pipes/format/transform-phone-no.pipe';

export const PHONE_VALIDATION_MASK = '000-000-0000';
export const PHONE_EXT_VALIDATION_MASK = '0{5}';

export function PhoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const transformer = new TransformPhoneNoPipe();
        let value = transformer.transform(control.value, []);
        if (value.length === 0) {
            return null;
        }

        if (value.length > 16) {
            return {invalidPhoneFormat: true};
        }

        value = value.replace(/-/g, '');
        value = value.replace(/[\s]/g, '');
        value = value.replace(/\(/g, '');
        value = value.replace(/\)/g, '');

        const regex = /^[\+]?[\d]{10,15}$/;
        if (!regex.test(value)) {
            return {invalidPhoneFormat: true};
        }

        return null;
    };
}

@Directive({
    selector: '[validatePhone][formControlName],[validatePhone][formControl],[validatePhone][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PhoneValidatorDirective),
            multi: true,
        },
    ],
})
export class PhoneValidatorDirective implements Validator
{
    validate(control: AbstractControl): { [key: string]: any } {
        const validator = PhoneValidator();
        return validator(control);
    }
}
